import { OrderConstant } from 'src/constants';
import { OrderActionDto, OrderTypeDto } from 'src/dtos';

const findEstimatedFee = (action?: OrderActionDto) => {
  return action === OrderActionDto.Buy ? OrderConstant.ESTIMATED_SERVICE_FEE : -OrderConstant.ESTIMATED_SERVICE_FEE;
};

export const findEstimatedTotal = ({
  type,
  action,
  value,
  quantity,
  price,
  stop,
}: {
  type?: OrderTypeDto;
  action?: OrderActionDto;
  value?: number;
  quantity?: number;
  price?: number;
  stop?: number;
}) => {
  if (type === OrderTypeDto.Market && value && quantity) {
    return value * quantity + findEstimatedFee(action);
  }

  if (type === OrderTypeDto.Limit && price && quantity) {
    return price * quantity + findEstimatedFee(action);
  }

  if (type === OrderTypeDto.StopLimit && price && quantity) {
    return price * quantity + findEstimatedFee(action);
  }

  if (type === OrderTypeDto.StopMarket && stop && quantity) {
    return stop * quantity + findEstimatedFee(action);
  }

  if (type === OrderTypeDto.MarketOnClose && value && quantity) {
    return value * quantity + findEstimatedFee(action);
  }

  return 0;
};
